import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutomationDetail = _resolveComponent("AutomationDetail")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_AutomationCard = _resolveComponent("AutomationCard")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_AutomationKindDialog = _resolveComponent("AutomationKindDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "py-8 px-4",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.openAutomation)
        ? (_openBlock(), _createBlock(_component_AutomationDetail, {
            key: 0,
            automation: _ctx.openAutomation,
            agents: _ctx.agents,
            workflows: _ctx.workflowChipItems,
            graph: _ctx.openWorkflowGraph,
            "run-state": _ctx.openRunState,
            running: _ctx.runInFlight,
            "onUpdate:automation": _ctx.onUpdate,
            onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openId = null)),
            onAddHelper: _ctx.onAddHelper,
            onSave: _ctx.onSave,
            onRun: _ctx.onRun,
            onDelete: _ctx.onDelete,
            onCancelRun: _ctx.onCancelRun,
            onPauseRun: _ctx.onPauseRun,
            onResumeRun: _ctx.onResumeRun
          }, null, 8, ["automation", "agents", "workflows", "graph", "run-state", "running", "onUpdate:automation", "onAddHelper", "onSave", "onRun", "onDelete", "onCancelRun", "onPauseRun", "onResumeRun"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "text-h4 font-weight-bold mb-2" }, "Automations", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", {
              class: "text-body-1 text-medium-emphasis mb-8",
              style: {"max-width":"580px"}
            }, " Work that runs for you — a daily briefing, a weekly report, an inbox that sorts itself. Each one is plain-English here — edit it, run it and watch progress without leaving the page. ", -1)),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6",
                  lg: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      variant: "outlined",
                      rounded: "lg",
                      height: "100%",
                      "min-height": "168",
                      class: "pa-6 d-flex flex-column justify-center ga-2 ms-add",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.picker = true))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_avatar, {
                          color: "primary",
                          variant: "tonal",
                          rounded: "lg",
                          size: "44"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-plus" })
                          ]),
                          _: 1
                        }),
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, "New automation", -1)),
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-caption text-disabled" }, "Describe it — I’ll build it", -1))
                      ]),
                      _: 1,
                      __: [4,5]
                    })
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (a) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    key: a.id,
                    cols: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AutomationCard, {
                        automation: a,
                        onOpen: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openId = $event))
                      }, null, 8, ["automation"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ], 64)),
      _createVNode(_component_AutomationKindDialog, {
        modelValue: _ctx.picker,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.picker) = $event)),
        onPick: _ctx.onPickKind
      }, null, 8, ["modelValue", "onPick"])
    ]),
    _: 1
  }))
}